/**
 * Leaderboard Admin API Endpoints
 * Status and on-demand triggering of the score-leaderboard recompute.
 *
 * Separate from `endpoints/leaderboard.ts`, which serves the per-adventure completion-TIME ladder.
 * These reach the analytics worker that owns the recompute, via the Admin API.
 */

import { ApiService } from '../apiService'
import type { RecomputeStatusResponse } from '../types/scoring'

export const leaderboardAdminApi = {
  /** The worker's last published recompute state. */
  getRecomputeStatus: () => ApiService.get<RecomputeStatusResponse>('/admin/leaderboards/admin/status'),

  /**
   * Asks the worker to rebuild the standings.
   * Rejects with 409 if a run is in flight, or 503 if no worker is listening.
   * The server answers in well under a second, so a short timeout means a lost response gives the
   * button back quickly instead of sitting on "Requesting…" for the client-wide 30s.
   */
  triggerRecompute: () =>
    ApiService.post<{ message: string }>('/admin/leaderboards/admin/recompute', undefined, { timeout: 15000 }),
}
